import {TextField, Button, Alert, Typography, Divider} from "@mui/material";
import {useHttp} from "../../hooks/useHttp";
import {FormEvent, useRef} from "react";
import "./Login.scss";
import {useNavigate} from "react-router";
import LoginIcon from '@mui/icons-material/Login';

interface LoginInterface {
    setAuthenticated: (authenticated: boolean) => void;
    closeModal: () => void;
}

export const Login = ({setAuthenticated, closeModal}: LoginInterface) => {
    const {trigger: login, error: loginError, loading: loginLoading} = useHttp<Response>("/login", {}, true);
    const passwordRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        login({
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
            data: {
                password: passwordRef.current?.value,
            },
        })
            .then((res) => {
                console.log(res)
                sessionStorage.setItem("authenticated", "true");
                sessionStorage.setItem("sessionId", res.data);
                setAuthenticated(true);
                closeModal();
                navigate("/tasks");
            })
            .catch((err) => {
                console.log(err)
            });
    };

    return (
        <form className='login' onSubmit={(e) => handleSubmit(e)}>
            <Typography variant={'h2'}>Log in</Typography>
            <TextField label="Password" type="password" variant="outlined" fullWidth margin="normal"
                       inputRef={passwordRef} className='login-input'/>
            <Button type="submit" variant="contained" color="primary" fullWidth>
                Submit
            </Button>
            {loginLoading && (
                <Alert className="login-alert" severity="info">
                    Loading...
                </Alert>
            )}
            {loginError && (
                <Alert className="login-alert" severity="error">
                    {loginError.status === 401 ? "Wrong password" : "Unknown error"}
                </Alert>
            )}
            <Divider className='login-divider'/>
            <Typography className='login-subtitle' variant={'h4'}>Don't have the password?</Typography>
            <Typography className='login-subtitle' variant={'body1'}>If you wish to try our application contact us
                at</Typography>
            <a href="mailto:przemyslaw.biecek@pw.edu.pl" className='login-link'>przemyslaw.biecek@pw.edu.pl</a>

        </form>
    );
};
